import { createFileRoute, redirect } from '@tanstack/react-router';
import moment from 'moment';

export const Route = createFileRoute('/weekplan/$year/$week/')({
  component: () => null,
  loader: ({ params }) => {
    throw redirect({
      to: '/weekplan/$year/$week/$day/{-$shiftId}',
      params: {
        year: params.year,
        week: params.week,
        day: moment().weekday().toString(),
      },
    });
  },
});
